import type { Language } from '../translations'

/** Locales live on production. Add each locale here after staging review. */
export const PRODUCTION_ENABLED_LANGUAGES = ['en'] as const satisfies readonly Language[]

/** Locales available on staging and localhost for review before production rollout. */
export const STAGING_ENABLED_LANGUAGES = [
  'en',
  'es',
  'fr',
  'pt',
  'de',
  'zh',
] as const satisfies readonly Language[]

/** Production web hosts where only {@link PRODUCTION_ENABLED_LANGUAGES} are selectable. */
export const PRODUCTION_WEB_HOSTS = ['zporti.com', 'www.zporti.com'] as const
